<template>
  <div class="d-flex flex-column">
    <div class="row justify-content-between mb-4">
      <div class="col-12 col-sm-4 d-flex">
        <card :title="$t('sections.lmLandingPage.numbers.title')" divider>
          <div class="row">
            <div class="d-flex flex-column col-auto">
              <HorizontalDetailTitle
                :label="$t('sections.lmLandingPage.numbers.locations')"
              />
              <HorizontalDetailTitle
                :label="$t('sections.lmLandingPage.numbers.evses')"
              />
              <HorizontalDetailTitle
                :label="$t('sections.lmLandingPage.numbers.connectors')"
              />
            </div>
            <div class="d-flex flex-column col-auto flex-fill pl-4">
              <HorizontalDetailInput :field="locationsNumber" :edit="false" />
              <HorizontalDetailInput :field="evsesNumber" :edit="false" />
              <HorizontalDetailInput :field="connectorsNumber" :edit="false" />
            </div>
          </div>
          <el-button type="primary" class="mt-3" @click="exportList">
            <font-awesome-icon icon="fa-light fa-file-csv" class="mr-2" />
            {{ $t("sections.lmLandingPage.downloadLocations") }}
          </el-button>
        </card>
      </div>
      <div class="col-12 col-sm-4">
        <PieChart
          v-if="!getLoading"
          :labels="locationsByConnectivityLabels"
          :datasets="locationsByConnectivityDatasets"
          :title="$t('sections.lmLandingPage.graph.locationsConnectivity')"
          class="mb-3"
          @click="handleConnectivityClick"
        />
      </div>
      <div class="col-12 col-sm-4">
        <PieChart
          v-if="!getLoading"
          :labels="evsesByStatusLabels"
          :datasets="evsesByStatusDatasets"
          :title="$t('sections.lmLandingPage.graph.evsesStatus')"
          class="mb-3"
          @click="handleStatusClick"
        />
      </div>
    </div>
    <span class="section-title" v-if="alarmsPermissions.read">
      {{ $t("sections.lmLandingPage.table.title") }}
    </span>
    <PaginationWrapper
      :page="page"
      :totalCount="totalCount"
      @onPageChange="handlePageChange"
      v-if="alarmsPermissions.read"
    >
     <!--  <div slot="table">
        <base-table :data="getAlarms">
          <el-table-column
            prop="id"
            :label="$t('sections.lmLandingPage.table.id')"
          />
          <el-table-column
            prop="locationId"
            :label="$t('sections.lmLandingPage.table.locationId')"
          />
          <el-table-column
            prop="issue"
            :label="$t('sections.lmLandingPage.table.issue')"
          />
          <el-table-column
            prop="severity"
            :label="$t('sections.lmLandingPage.table.severity')"
          />
          <el-table-column
            prop="evseId"
            :label="$t('sections.lmLandingPage.table.evseId')"
          />
          <el-table-column
            prop="status"
            :label="$t('sections.lmLandingPage.table.status')"
          />
          <el-table-column fixed="right" width="60">
            <template slot="header">
              <div class="button-placeholder" />
            </template>
            <template slot-scope="props">
              <div class="d-flex justify-content-center">
                <el-dropdown trigger="click">
                  <div class="outline-icon-button">
                    <font-awesome-icon icon="fa-regular fa-ellipsis-vertical" />
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <router-link
                        :to="{
                          name: 'Alarm Detail',
                          params: {
                            id: props.row.id,
                            alarm: props.row,
                          },
                        }"
                      >
                        {{ $t("sections.alarms.options")[0] }}
                      </router-link>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </base-table>
      </div> -->

      <AlarmsSearchOptions @onSearch="handleSearch" slot="search-options" :modules=false />
      <AlarmsTable slot="table" />
    </PaginationWrapper>
  </div>
</template>
<script>
/* eslint-disable global-require */
import { mapGetters } from 'vuex';
import HorizontalDetailTitle from '@/components/ui/HorizontalDetailTitle.vue';
import HorizontalDetailInput from '@/components/ui/HorizontalDetailInput.vue';
import PieChart from '@/components/ui/charts/PieChart.vue';
import PaginationWrapper from '@/components/sections/common/PaginationWrapper.vue';
import AlarmsTable from '@/components/sections/alarms/AlarmsTable';
import AlarmsSearchOptions from '@/components/sections/alarms/AlarmsSearchOptions';

export default {
  name: 'LocationsManagerLandingPage',
  components: {
    HorizontalDetailTitle,
    HorizontalDetailInput,
    PieChart,
    PaginationWrapper,
    AlarmsTable,
    AlarmsSearchOptions,
  },
  data() {
    return {
      locationsNumber: 0,
      evsesNumber: 0,
      connectorsNumber: 0,
      locationsByConnectivityLabels: [],
      locationsByConnectivityValues: [],
      locationsByConnectivityDatasets: [],
      evsesByStatusValues: [],
      evsesByStatusLabels: [],
      evsesByStatusDatasets: [],
      page: 1,
      totalCount: 0,
      query: {},
    };
  },
  computed: {
    ...mapGetters(['getLoading', 'getAlarms', 'getPagePermissions']),
    alarmsPermissions() {
      return this.getPagePermissions('Alarms Manager - Alarms');
    },
    locationsPermissions() {
      return this.getPagePermissions('Locations Manager - Locations');
    },
  },
  async mounted() {
    this.$store.dispatch('storeLoading', true);
    try {
      await this.fetchData();
    } catch (e) {
      console.log(e);
      console.log("Couldn't fetch data.");
    }
    try {
      await this.fetchAlarmsData();
    } catch (e) {
      console.log(e);
      console.log("Couldn't get alarms data.");
    }
    this.$store.dispatch('storeLoading', false);
  },
  methods: {
    async handleSearch(query) {
      this.page = 1;
      this.query = query;
      await this.fetchAlarmsData();
    },
    async fetchAlarmsData() {
      this.totalCount = await this.$store.dispatch('storeAlarms', {
        query: {
          ...this.query,
          module: 'Locations Manager',
        },
        page: this.page,
      });
    },
    async fetchData() {
      try {
        const {
          locationsTotalCount,
          evsesTotalCount,
          connectorsTotalCount,
          locationsByConnectivity,
          evsesByStatus,
        } = await this.$store.dispatch('getLocationsAnalytics');

        this.locationsNumber = locationsTotalCount;
        this.evsesNumber = evsesTotalCount;
        this.connectorsNumber = connectorsTotalCount;

        const locsConnectPromise = this.loadLocationsConnectivityGraph(
          locationsByConnectivity,
        );

        const evsesStatusPromise = this.loadEVSEsStatusGraph(evsesByStatus);

        await Promise.allSettled([locsConnectPromise, evsesStatusPromise]);
      } catch (e) {
        console.log("Couldn't fetch data.");
      }
    },
    async loadLocationsConnectivityGraph(locationsByConnectivity) {
      const locationsByConnectivityColors = [];

      await Promise.all(
        locationsByConnectivity.map(async (e) => {
          if (e._id === 'ONLINE') {
            locationsByConnectivityColors.push('#2d988c');
            this.locationsByConnectivityLabels.push(
              this.$t(
                'sections.lmLandingPage.locationsConnectivityLabels.online',
              ),
            );
            this.locationsByConnectivityValues.push(e.count);
          } else if (e._id === 'OFFLINE') {
            locationsByConnectivityColors.push('#df8a8a');
            this.locationsByConnectivityLabels.push(
              this.$t(
                'sections.lmLandingPage.locationsConnectivityLabels.offline',
              ),
            );
            this.locationsByConnectivityValues.push(e.count);
          }
        }),
      );

      this.locationsByConnectivityDatasets = [
        {
          backgroundColor: locationsByConnectivityColors,
          borderColor: locationsByConnectivityColors,
          data: this.locationsByConnectivityValues,
        },
      ];
    },
    async loadEVSEsStatusGraph(evsesByStatus) {
      const evsesByStatusColors = [];

      await Promise.all(
        evsesByStatus.map(async (e) => {
          if (e._id === 'AVAILABLE') {
            evsesByStatusColors.push('#2d988c');
            this.evsesByStatusLabels.push(
              this.$t('sections.lmLandingPage.evsesStatusLabels.available'),
            );
            this.evsesByStatusValues.push(e.count);
          } else if (e._id === 'BLOCKED') {
            evsesByStatusColors.push('#e9ac4a');
            this.evsesByStatusLabels.push(
              this.$t('sections.lmLandingPage.evsesStatusLabels.blocked'),
            );
            this.evsesByStatusValues.push(e.count);
          } else if (e._id === 'CHARGING') {
            evsesByStatusColors.push('#ffd60a');
            this.evsesByStatusLabels.push(
              this.$t('sections.lmLandingPage.evsesStatusLabels.charging'),
            );
            this.evsesByStatusValues.push(e.count);
          } else if (e._id === 'INOPERATIVE') {
            evsesByStatusColors.push('#df8a8a');
            this.evsesByStatusLabels.push(
              this.$t('sections.lmLandingPage.evsesStatusLabels.inoperative'),
            );
            this.evsesByStatusValues.push(e.count);
          } else if (e._id === 'OUTOFORDER') {
            evsesByStatusColors.push('#ebebeb');
            this.evsesByStatusLabels.push(
              this.$t('sections.lmLandingPage.evsesStatusLabels.outOfOrder'),
            );
            this.evsesByStatusValues.push(e.count);
          } else if (e._id === 'PLANNED') {
            evsesByStatusColors.push('#0088cf');
            this.evsesByStatusLabels.push(
              this.$t('sections.lmLandingPage.evsesStatusLabels.planned'),
            );
            this.evsesByStatusValues.push(e.count);
          } else if (e._id === 'REMOVED') {
            evsesByStatusColors.push('#000000');
            this.evsesByStatusLabels.push(
              this.$t('sections.lmLandingPage.evsesStatusLabels.removed'),
            );
            this.evsesByStatusValues.push(e.count);
          } else if (e._id === 'RESERVED') {
            evsesByStatusColors.push('#1b4332');
            this.evsesByStatusLabels.push(
              this.$t('sections.lmLandingPage.evsesStatusLabels.reserved'),
            );
            this.evsesByStatusValues.push(e.count);
          } else if (e._id === 'UNKNOWN') {
            evsesByStatusColors.push('#727272');
            this.evsesByStatusLabels.push(
              this.$t('sections.lmLandingPage.evsesStatusLabels.unknown'),
            );
            this.evsesByStatusValues.push(e.count);
          }
        }),
      );

      this.evsesByStatusDatasets = [
        {
          backgroundColor: evsesByStatusColors,
          borderColor: evsesByStatusColors,
          data: this.evsesByStatusValues,
        },
      ];
    },
    async handlePageChange(page) {
      this.$store.dispatch('storeLoading', true);
      this.page = page;
      await this.fetchAlarmsData();
      this.$store.dispatch('storeLoading', false);
    },
    handleConnectivityClick(e) {
      this.$router.push({
        name: 'Locations',
        params: { connectivity: e.label },
      });
    },
    handleStatusClick(e) {
      if (e.label === 'Planned' || e.label === 'Removed') {
        this.$router.push({
          name: 'Locations',
          params: { status: e.label },
        });
      } else {
        this.$router.push({
          name: 'Locations',
          params: { state: e.label },
        });
      }
    },
    async exportList() {
      await this.$store.dispatch('storeLoading', true);

      try {
        const file = await this.$store.dispatch('exportLocations', {
          query: {},
          type: 'locations',
        });

        if (file.data === '') {
          this.$message.error(
            this.$t('components.alerts.exportFileError', { type: 'locations' }),
          );
        } else {
          const fileURL = window.URL.createObjectURL(new Blob([file.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute(
            'download',
            `locations-${new Date()
              .toISOString()
              .slice(0, 10)
              .replaceAll('-', '')}.csv`,
          );
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$message.success(
            this.$t('components.alerts.exportSuccess', { type: 'locations' }),
          );
        }
      } catch (e) {
        this.$message.error(
          this.$t('components.alerts.exportError', { type: 'locations' }),
        );
        console.log(e);
      }

      await this.$store.dispatch('storeLoading', false);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .card--body > div:first-child {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
</style>
